import script from "./landlord-consent-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./landlord-consent-page.vue?vue&type=script&setup=true&lang=ts"

import "./landlord-consent-page.vue?vue&type=style&index=0&id=37190fe4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37190fe4"]])

export default __exports__